import ReleaseBuilderMockup from '@/components/marketing/technology/ReleaseBuilderMockup'
import TechnologyDetailPage from '@/components/marketing/technology/TechnologyDetailPage'
import type { TechnologyDetailProps } from '@/types/technology'

/* The technology section — the release builder, in full.
 *
 * A child of /technology/platform rather than a sixth sibling. The parent shows
 * a wireframe and links here; stacking this mock and the analytics one on the
 * parent made it enormously tall before a reader reached a single capability.
 */
export default function ReleaseBuilder(props: TechnologyDetailProps) {
  return <TechnologyDetailPage {...props} visual={<ReleaseBuilderMockup />} />
}
